// extracted by mini-css-extract-plugin
export var galleryWrapper = "gallery-module--galleryWrapper--Z89wN";
export var topRow = "gallery-module--topRow--2aehQ";
export var navigation = "gallery-module--navigation--3P38_";
export var active = "gallery-module--active--1RVgT";
export var inactive = "gallery-module--inactive--3yy7g";
export var separator = "gallery-module--separator--2QfWO";
export var title = "gallery-module--title--3I3iQ";
export var quote = "gallery-module--quote--2OzIN";
export var middleQuote = "gallery-module--middleQuote--2_TjN";
export var description = "gallery-module--description--2XqJF";
export var properties = "gallery-module--properties--SCUco";
export var propertyPairContainer = "gallery-module--propertyPairContainer--31WcU";
export var bottomRuler = "gallery-module--bottomRuler--KSZoH";
export var wallParagraph = "gallery-module--wallParagraph--1En9J";
export var contact = "gallery-module--contact--2hW0D";
export var titleMobile = "gallery-module--titleMobile--37EU6";